<template>
  <!-- ログアウト、メニュー無し版 -->
  <v-app id="inspire">
    <v-app-bar
      app
      flat
      dark
      color="#000000"
    >
      <router-link to="/" style="text-decoration: none; color: #FFFFFF;" class="d-block d-md-block">
        <v-img v-if="!$vuetify.breakpoint.xs" src="../assets/logo.png" max-width="360" max-height="47" class="mr-3"></v-img>
        <v-img v-if="$vuetify.breakpoint.xs" src="../assets/logo.png" max-width="240" max-height="26" class="mr-3"></v-img>
      </router-link>
      <v-spacer></v-spacer>
      <MpLang />
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>

    <MpFooter />
  </v-app>
</template>

<script>
import MpFooter from '@/components/parts/MpFooter.vue'
import MpLang from '@/components/parts/MpLang.vue'

export default {
  components: {
    MpFooter,
    MpLang
  },
  props: {
    source: String
  },
  data: () => ({}),
  created () {
    this.$vuetify.theme.dark = false
  }
}
</script>

<style>
div.v-toolbar__title {
  font-size: 2.0rem;
}
</style>
